import { CalendarCheck, CalendarDays } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router";
import { Card, CardHeader, CardContent, CardTitle } from "./ui/card";

const VisitsHistoryStub = () => {
  const navigate = useNavigate();
  return (
    <Card className="overflow-hidden border-none shadow-none">
      <CardHeader className="w-[calc(100vw-1.5rem)] md:w-[calc(100vw-250px)] lg:w-[50.4rem]">
        <div className="flex flex-col gap-2">
          <div className="group mx-auto flex flex-col items-center gap-3">
            <div className="rounded-full bg-primary/5 p-6">
              <CalendarCheck className="h-12 w-12 text-primary/60" />
            </div>
            <CardTitle className="text-lg font-medium text-gray-800 transition-colors group-hover:text-primary">
              История посещений пуста
            </CardTitle>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 py-4">
        <div className="space-y-1 text-center">
          <div className="pb-2 text-sm text-muted-foreground">
            <p className="mx-auto max-w-[300px]">
              Здесь будет отображаться информация о ваших посещениях
            </p>
          </div>
          <div className="mt-[20px]">
            <Button variant="outline" className="mt-2" onClick={() => navigate("/sign-up")}>
              <CalendarDays className="mr-2 h-4 w-4" />
              Перейти к расписанию
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
export default VisitsHistoryStub;
